export default "__VITE_ASSET__b994a8d2__"